//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import starValue from './starValue.vue'
import native from '../../lib/native'
export default {
  props: {
    data: {
      type: Object
    },
    isBottom: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      kaiT:false
    }
  },
  created(){
    // console.log(this.data,'========================')
        if(this.$route.path=='/clinic/clinicDoctorOrKeshi'){
          // console.log(this.$route.path)
         this.kaiT=false
        }else{
          this.kaiT=true
        }
  },
  computed: {
    goodAtValue: function () {
      let str = '',
          len = this.data.goodAt.lenght
      this.data.goodAt.forEach(function (item, index, arr) {
        if (index < len) {
          str += i + '<span class="separate"></span>'
        } else {
          str += i
        }
      })
      return str
    },
    effectData: function () {
      return { value: this.data.effect / 100 }
    },
    attitudeData: function () {
      return { value: this.data.attitude / 100 }
    }
  },
  methods:{
      goDoctorsDetail(id){
        var origin=location.origin
        native.openwebview(JSON.stringify({
            linkurl:`${origin}/clinic/doctorDetail/${id}`,
            ifNavigation:'1',
            tipsTopNav:'1',
            isRefresh:'1'
        }));
      },
  },
  components: {
    starValue
  }
}



// WEBPACK FOOTER //
// ./src/components/clinic/doctorCard.vue